import * as types from '../mutation-types'
import user from '../../api/user'

/**
 * Prevent multiple parallel requests from API.
 */
let inboxPromise;

/**
 * Inbox set timeout.
 */
let inboxTimeout;

const state = {
    newCommentsCount: 0,
    newMessagesCount: 0,
    inboxStatsLoading: false,
};

const getters = {

    inboxStats: state => {
        return {
            newCommentsCount: state.newCommentsCount,
            newMessagesCount: state.newMessagesCount,
        }
    }

};

const actions = {

    getInboxStats({ commit, dispatch }) {

        clearTimeout(inboxTimeout);

        if (state.inboxStatsLoading) {
            return inboxPromise;
        } else {
            commit(types.LOADING_INBOX_STATS)

            inboxPromise = user.inboxStatistics()
                .then(response => {
                    commit(types.UPDATE_INBOX_STATISTICS, response.data)
                    commit(types.IDLE_INBOX_STATS)
                    inboxTimeout = setTimeout(() => dispatch('getInboxStats'), 15000)

                    return response;
                }, response => {
                    commit(types.IDLE_INBOX_STATS)
                    return response;
                })
                .catch(error => {
                    commit(types.IDLE_INBOX_STATS)
                    throw error
                });

            return inboxPromise;
        }
    },



};

const mutations = {

    [types.UPDATE_INBOX_STATISTICS] (state, { new_comments_count, new_messages_count }) {
        state.newCommentsCount = new_comments_count;
        state.newMessagesCount = new_messages_count;
    },

    [types.LOADING_INBOX_STATS] (state) {
        state.inboxStatsLoading = true;
    },

    [types.IDLE_INBOX_STATS] (state) {
        state.inboxStatsLoading = false;
    }

};

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/inbox.js